import { makeReference, useApolloClient } from '@apollo/client';
import { usePreviousProp } from '@infl-ts/util-hooks';
import { useRefetchQueries } from '@infl-ts/util-use-refetch-queries';
import { pipe } from 'fp-ts/function';
import { useEffect } from 'react';
import { useChallengePlayer } from './use-challenge-player';
export var useRefetchOnChallengeClose = function useRefetchOnChallengeClose(queriesToFetch) {
  var _useChallengePlayer = useChallengePlayer(),
      open = _useChallengePlayer.challengePlayerState.open;

  var prevIsPlayerOpen = usePreviousProp(open);

  var _useApolloClient = useApolloClient(),
      cache = _useApolloClient.cache;

  useEffect(function () {
    pipe(cache.identify(makeReference('ROOT_QUERY')), function (rootQueryId) {
      if (prevIsPlayerOpen && !open) {
        cache.evict({
          id: rootQueryId,
          fieldName: 'availableChallenges'
        });
        cache.evict({
          id: rootQueryId,
          fieldName: 'savedForLaterChallenges'
        });
        cache.evict({
          id: rootQueryId,
          fieldName: 'pendingApprovalChallenges'
        });
        cache.evict({
          id: rootQueryId,
          fieldName: 'completedChallenges'
        });
        cache.evict({
          id: rootQueryId,
          fieldName: 'channels'
        });
        cache.evict({
          id: rootQueryId,
          fieldName: 'challengeByIds'
        });
        cache.evict({
          id: rootQueryId,
          fieldName: 'challengeCategories'
        });
        cache.evict({
          id: rootQueryId,
          fieldName: 'profile'
        });
        cache.evict({
          id: rootQueryId,
          fieldName: 'member'
        });
        cache.gc();
      }
    });
  }, [cache, open, prevIsPlayerOpen]);
  useRefetchQueries({
    queriesToFetch: queriesToFetch,
    skip: prevIsPlayerOpen === open || open
  });
};